const community = localStorage.getItem("community");

export const communityURL =
  community === "my"
    ? "https://www.instagram.com/channel/AbYfkl2aJ0Y8y808/"
    : community === "tw"
    ? "https://line.me/ti/g2/0P-QxB04q_ombtXadXrtEUndiwjRkdOINPVX3g?utm_source=invitation&utm_medium=link_copy&utm_campaign=default"
    : community === "id"
    ? "https://www.instagram.com/sotravel_id"
    : "https://t.me/sotravel_sg";

export const instagramURL =
  community === "my"
    ? "https://www.instagram.com/avider_official"
    : community === "tw"
    ? "https://www.instagram.com/sotravel_tw"
    : community === "id"
    ? "https://www.instagram.com/sotravel_id"
    : "https://www.instagram.com/sotravel_sg";

export const baseURL =
  process.env.REACT_APP_BASE_URL || "http://localhost:8080";

export const isProd = process.env.NODE_ENV === "production";

export const telegramBotUsername = isProd
  ? "sotravel_bot"
  : process.env.REACT_APP_TELEGRAM_BOT_USERNAME;

export const telegramSupport = "https://t.me/sotravel_official";
export const whatsappSupport = "https://wa.link/xbix78";
export const lineSupport = "https://line.me/R/ti/p/@073smnfj";
export const wechatSupport = "avider_666";

export const FIREBASE_AUTH_TOKEN_KEY = "FIREBASE_AUTH_TOKEN";

export const seoDescription = "Adventures that last a lifetime";

export const contactUsURL =
  community === "sg"
    ? telegramSupport
    : community === "tw"
    ? lineSupport
    : whatsappSupport;

export const landingVideoDesktop =
  community === "my"
    ? "https://d1puf2nnbcyl9q.cloudfront.net/avider_landing_website_desktop.mov"
    : "https://d1puf2nnbcyl9q.cloudfront.net/desktop_landing.mp4";

export const landingVideoMobile =
  community === "my"
    ? "https://d1puf2nnbcyl9q.cloudfront.net/avider_landing_website_mobile.mov"
    : "https://d1puf2nnbcyl9q.cloudfront.net/mobile_landing.mov";

export const landingImageDesktop =
  community === "my"
    ? "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/9061564image_2025-05-12_21-28-06.png"
    : "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/5311594image_2025-05-12_21-29-04.png";

export const landingImageMobile =
  community === "my"
    ? "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/2550419image_2025-05-12_21-28-20.png"
    : "https://sotravel-agent-folder.s3.ap-southeast-1.amazonaws.com/%2Frandom/1282858image_2025-05-13_00-07-20.png";

export const countryWithLandingPage = ["mongolia"];

export const defaultBroadCategories = (community) => {
  if (community === "sg") {
    return {
      surf: true,
      dive: true,
      land: true,
      snow: true,
      360: true,
      club: true,
    };
  } else if (community === "tw" || community === "hk") {
    return {
      surf: false,
      dive: true,
      land: true,
      snow: true,
      360: true,
      club: false,
    };
  } else if (community === "my") {
    return {
      surf: true,
      dive: true,
      land: true,
      snow: true,
      360: true,
      club: false,
    };
  } else if (community === "id") {
    return {
      surf: false,
      dive: false,
      land: false,
      snow: false,
      360: false,
      club: false,
    };
  } else {
    // Default case
    return {
      surf: true,
      dive: true,
      land: true,
      snow: true,
      360: true,
      club: true,
    };
  }
};
